import styled from 'styled-components';
export const Container = styled.div `
  width: 100%;
  height: 100%;
  position: relative;
`;
export const EmptyMessage = styled.div `
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "Suisse Int'l", sans-serif;
  color: var(--text-secondary);
`;
export const Chart = styled.div `
  width: 100%;
  height: 100%;
`;
